import axios from 'axios'
import { API_URL } from '../constants'

export const getComposedSimulationName = async (body: any) => {
  const url = `${API_URL}/phishing-simulations/compose-simulation-name/`
  const response = await axios.post(url, body, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  })
  return response.data.generated_name
}
